export const firstPageComponent = (role: string) => {
  let path: string;
  switch (role) {
    case 'DRIVER':
      path = '/driver-management'
      break;
    default:
      path = '/driver-management';
  }
  return path;
};
